// extracted by mini-css-extract-plugin
export default {"thead":"TableHead_thead__up21J"};